export default "__VITE_ASSET__BnGj0Hu2__"